import { useEffect, useState } from 'react';
import { getApiBaseUrl } from "../utils/apiAssetUrl";
import '../CSS/Global.css';
import user from "../Images/user.jpg"
import { Box, Button } from '@chakra-ui/react';
import Header from './Header';

const apiBase = getApiBaseUrl();

/** Stored QR URLs may point at an old hostname; swap to current API host for /Images/QR/... */
function normalizeQrImageUrl(scanqr) {
    if (scanqr == null || typeof scanqr !== 'string') return null;
    const t = scanqr.trim();
    if (!t || t === 'null' || t === 'undefined') return null;
    if (t.startsWith('data:image')) return t;
    if (t.includes('/Images/QR/')) {
        return t.replace(/^https?:\/\/[^/]+/i, apiBase);
    }
    return t;
}

const ShowQR = () => {
    const login = JSON.parse(localStorage.getItem("login")) || ""
    const [qruse, setQr] = useState()
    const [permanentID, setPermanent] = useState()
    const [username, setUsername] = useState()
    const [profile, setProfile] = useState();
    const [qrImageFailed, setQrImageFailed] = useState(false);

    const fetchShow = async () => {
        try {
            const response = await fetch(`${apiBase}/register/singleuser/${login.permanent_ID}`)
            const res = await response.json();
            setQr(res.scanqr)
            setPermanent(res.permanent_ID)
            setUsername(res.name)
            setProfile(res.profilePic);
            setQrImageFailed(false);
        } catch (error) {
            console.log(error)
        }
    }

    const handleGenrateQr = async () => {
        try {
            const response = await fetch(`${apiBase}/register/api/generate-qr`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ permanent_ID: login.permanent_ID }),
            })
            const res = await response.json();
            console.log(res);
            if (response.ok) {
                fetchShow();
            }
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        fetchShow();
    }, [])

    const qrSrc = normalizeQrImageUrl(qruse);
    const showGenerate = !qrSrc || qrImageFailed;

    return (
        <>
        <Header/>
            <div className='qr'>
                <div className='qr-main'>
                    <img src={profile === null || !profile ? user : `${apiBase}/${String(profile).replace(/^\//, '')}`} alt='Placeholder' className='person-img' />

                    <p className='name'>{username}</p>

                    <div className='qr-img'>
                        {
                            showGenerate ?
                                <Box marginTop={"40px"} >
                                    <Button bgGradient="linear(to-r, #0041FF, #6C3BFF, #E6007E)" onClick={handleGenrateQr} color={"#fff"} display={"block"} margin={"auto"}>Generate QR</Button>
                                </Box>
                                : <img src={qrSrc} alt='QR Code' onError={() => setQrImageFailed(true)} />

                        }

                    </div>

                    <div className='qr-id'>
                        <p>Customer ID: {permanentID}</p>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ShowQR;
